const OPEN_DIALOG = '[role$="dialog"][data-state="open"]';

export function refocus(opener: Element | null): void {
  const top = [...document.querySelectorAll<HTMLElement>(OPEN_DIALOG)].pop();
  if (opener instanceof HTMLElement && document.contains(opener) && (!top || top.contains(opener)))
    opener.focus({ preventScroll: true });
  else if (top && !top.contains(document.activeElement)) top.focus({ preventScroll: true });
}
